const MUTATIONS = {

/* =====================================================================
	Config
	==================================================================== */

	SET_CONFIG_DATA: "global/api/setConfig",
	COMPLETE_CONFIG: "global/api/completeConfigLoad",

/* =====================================================================
	Preloader
	==================================================================== */

	SET_PRELOADER_PROGRESS: "global/assets/setProgress",
	SET_PRELOADER_STATUS: "global/assets/setStatus",

/* =====================================================================
	SOUND
	==================================================================== */

	TOGGLE_MUTE: "sound/toggle",
	CREATE_SOUND: "sound/create",
	REMOVE_SOUND: "sound/remove",
	CONTROL_SOUND: "sound/control",

	TRACK_SOUND: "sound/fx/track",
	UNTRACK_SOUND: "sound/fx/untrack",

	PLAY_MUSIC: "sound/music/play",
	PAUSE_MUSIC: "sound/music/stop",
	STOP_MUSIC: "sound/music/stop",

/* =====================================================================
	Modal
	==================================================================== */

	ACTIVATE_MODAL_WINDOW: "global/modal/activate",
	DEACTIVATE_MODAL_WINDOW: "global/modal/deactivate",

/* =====================================================================
	Game Status
	==================================================================== */

	START_GAME: "game/start",
	COMPLETE_GAME: "game/complete",
	PAUSE_GAME: "game/pause",
	UNPAUSE_GAME: "game/unpause",

/* =====================================================================
	Tutorial
	==================================================================== */

	ACTIVATE_TUTORIAL: "tutorial/activate",
	DEACTIVATE_TUTORIAL: "tutorial/deactivate",
	SET_TUTORIAL_STEP_INDEX: "tutorial/steps/setIndex",

	ACTIVATE_TUTORIAL_MASK: "tutorial/mask/activate",
	DEACTIVATE_TUTORIAL_MASK: "tutorial/mask/deactivate",

/* =====================================================================
	Hints
	==================================================================== */

	HINT_TRIGGER_SUBSCRIBE: "subscribeHintTrigger",
	HINT_TRIGGER_SET_STATUS: "activateHintTrigger",
	ACTIVATE_HINT: "activateHint",
	COMPLETE_HINT: "completeHint",

/* =====================================================================
	Balance
	==================================================================== */

	SET_BALANCE: "game/balance/setBalance",

/* =====================================================================
	Chapters
	==================================================================== */

	POPULATE_CHAPTERS: "game/chapters/populate",
	SET_CHAPTER_INDEX: "game/chapters/setIndex",
	SET_CHAPTER_BALANCE: "game/chapters/active/setBalance",
	DISABLE_CURVEBALL_ACTIVATION: "game/chapters/active/disableCurveballActivation",

/* =====================================================================
	Chapters // Curveballs
	==================================================================== */

	ACCEPT_CURVEBALL: "acceptCurveball",
	SET_CURVEBALL_ACTIVATION: "activateCurveball",
	RETURN_CURVEBALL: "returnCurveball",

/* =====================================================================
	Scores
	==================================================================== */

	SET_SCORE: "game/scores/set",
	STORE_SCORE_CHANGE: "game/scores/storeChange",

/* =====================================================================
	Funds
	==================================================================== */

	SET_FUND_BALANCE: "game/funds/set",

/* =====================================================================
	Budgets
	==================================================================== */

	POPULATE_BUDGETS: "game/budgets/populate",
	ADD_BUDGET: "game/budgets/add",
	REMOVE_BUDGET: "game/budgets/remove",

	ALLOCATE_BUDGET: "allocateBudget",
	RESET_BUDGET: "resetBudget",

/* =====================================================================
	Tricks
	==================================================================== */

	POPULATE_TRICKS: "game/tricks/populate",
	SET_TRICK_OWNERSHIP: "setOwnership",
	SET_TRICK_SELECTION: "toggleSelectuion",

/* =====================================================================
	Performance
	==================================================================== */

	ADD_TRICK_TO_PERFORMANCE: "game/performance/addTrick",
	REMOVE_TRICK_FROM_PERFORMANCE: "game/performance/removeTrick",

/* =====================================================================
	Routes
	==================================================================== */

	ROUTE_CHANGED: "route/ROUTE_CHANGED",

};

export const ROOT = MUTATIONS;
export const LOCAL = Object.entries(MUTATIONS)
	.map(([key, path]) => [key, /[^/]*$/.exec(path)])
	.reduce((obj, [key, value]) => ({ ...obj, [key]: value[0] }), {});

export const ROOT_FLAG = { root: true };



// WEBPACK FOOTER //
// ./src/store/mutations.js